import { Slide } from "packages/lesson/dist/@types";
import { task as task01 } from "../../../../../task/course-03/lesson-10/task-01";

const task: Slide = {
  title: `What does Lambert's cosine law describe?`,
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
